import * as cs from 'classnames';
import * as React from 'react';
import { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { MenuItem as MenuItemModel } from '../contentful/contentfulClient';
import { isEmpty } from 'lodash';
import './MenuItems.css';

export interface MainMenuProperties {
    currentPathname: string;
    menuItems: Array<MenuItemModel>;
    expanded: boolean;
}

export interface MenuItemsProps {
    currentPathname: string;
    menuItems: Array<MenuItemModel>;
    root: string;
    level: number;
    visible: boolean;
}

interface MenuItemProps {
    currentPathname: string;
    menuItem: MenuItemModel;
    root: string;
    level: number;
    showSubItems: boolean;
}

/* tslint:disable:no-use-before-declare */

export const MenuItems: React.FC<MenuItemsProps> = ({root, menuItems, level, visible, currentPathname}) => (
    <ul className={cs('menu-items', `menu-items-level-${level}`, {'menu-items-hide': !visible})}>
        {menuItems.map(item => <MenuItem
            key={item.id}
            root={root}
            menuItem={item}
            level={level}
            showSubItems={false}
            currentPathname={currentPathname}
        />)}
    </ul>
);

const subRoot: (root: string, path: string) => string =
    (root, path = '') => `${root.endsWith('/') ? root : `${root}/`}${path}`;

const menuItemInitialState = {showSubItems: false};
type MenuItemState = Readonly<typeof menuItemInitialState>;

class MenuItem extends React.Component<MenuItemProps, MenuItemState> {
    readonly state: MenuItemState = menuItemInitialState;

    show = visible => () => (this.setState((prev: MenuItemState) => ({...prev, showSubItems: visible})));

    render() {
        const {
            root,
            currentPathname,
            level,
            menuItem: {name, category, clickable, subMenuItems},
        } = this.props;
        const path = subRoot(root, category);
        const {showSubItems} = this.state;
        const selected = currentPathname.startsWith(path);
        const linkText = <span className={cs({selected})}>{name}</span>;
        const selectedItem = selected ? `menu-item-level-${level}--selected` : null;
        return (
            <li
                className={cs('menu-item', `menu-item-level-${level}`, `${selectedItem}`)}
                onMouseEnter={this.show(true)}
                onMouseLeave={this.show(false)}
                onClick={this.show(!this.state.showSubItems)}
            >
                {clickable ?
                    <Link to={path}>
                        <div>
                            {linkText}
                        </div>
                    </Link>
                    : linkText
                }
                {!isEmpty(subMenuItems) &&
                <MenuItems
                    root={path}
                    menuItems={subMenuItems || []}
                    level={level + 1}
                    visible={showSubItems}
                    currentPathname={currentPathname}
                />}
            </li>
        );
    }
}

export const MainMenu: React.FC<MainMenuProperties & HTMLAttributes<HTMLDivElement>> =
    ({menuItems, className, currentPathname, expanded}) => (
        <div className={cs('main-menu', {'main-menu--expanded': expanded}, className)}>
            <MenuItems root={'/'} menuItems={menuItems} level={1} visible={true} currentPathname={currentPathname}/>
        </div>
    );



// WEBPACK FOOTER //
// ./src/menu/MenuItems.tsx